import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart } from "lucide-react";

const FAQ = [
  {
    q: "Qui est Maryline ?",
    a: "Maryline est l'interlocutrice de l'expérience RawLove. Elle écoute, reformule, pose des questions et aide à distinguer les faits, les ressentis et les interprétations, avant de préparer l'analyse RawLove. Elle n'est pas une personne : les conversations avec Maryline et les analyses sont produites par des systèmes automatisés.",
  },
  {
    q: "Comment fonctionne RawLove ?",
    a: "RawLove utilise des systèmes d'intelligence artificielle pour accompagner les conversations avec Maryline et produire des analyses personnalisées à partir des informations fournies par l'utilisateur. La méthode RawLove impose de toujours séparer ce qui est observé, ce qui est ressenti, ce qui est interprété et ce qui reste inconnu — et de ne jamais prétendre connaître les pensées ou les intentions d'une autre personne.",
  },
  {
    q: "Que contient l'analyse complète ?",
    a: "Ce que les faits montrent, la distinction faits / interprétations / hypothèses, ce que la situation peut signifier, les comportements qui méritent attention (red & green flags), une réponse à la question centrale, un plan d'action concret, et ce que nous savons / ne savons pas encore. Elle coûte 4,99 € et est accessible une fois la conversation terminée.",
  },
  {
    q: "Mes échanges sont-ils confidentiels ?",
    a: "Oui. Les conversations sont conservées de façon sécurisée pour produire l'analyse et ne sont jamais partagées. Une conversation et son analyse peuvent être supprimées intégralement sur demande.",
  },
  {
    q: "RawLove remplace-t-il un professionnel ?",
    a: "Non. RawLove n'est ni un service d'urgence ni un professionnel de santé mentale. En cas de danger, de violence ou de détresse, contactez les services compétents (en France : 3919 pour les violences conjugales, 15 ou 112 en urgence).",
  },
];

export default function About() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[100dvh] bg-[#FAF7F2]">
      <div className="max-w-2xl mx-auto px-5 py-6">
        <button onClick={() => navigate(-1)} data-testid="about-back"
          className="inline-flex items-center gap-1.5 text-sm text-[#5C4A45] hover:text-[#6E2D38] transition-colors">
          <ArrowLeft className="w-4 h-4" /> Retour
        </button>
        <header className="mt-8 mb-10">
          <p className="text-[11px] tracking-[0.2em] uppercase text-[#B08A82] font-semibold mb-2">À propos & transparence</p>
          <h1 className="font-editorial text-4xl sm:text-5xl font-semibold leading-[1.05] text-[#2B1E1B]">
            La méthode RawLove, et ce qu'il y a derrière.
          </h1>
        </header>

        <section data-testid="about-transparency"
          className="bg-white border border-[#E8DDD5] rounded-2xl p-6 mb-8 shadow-[0_4px_20px_-4px_rgba(110,45,56,0.06)]">
          <h2 className="font-editorial text-2xl font-semibold text-[#2B1E1B] mb-3">Transparence</h2>
          <p className="text-[15px] text-[#4A3B37] leading-relaxed">
            RawLove utilise des systèmes d'intelligence artificielle pour accompagner les conversations avec Maryline
            et produire des analyses personnalisées à partir des informations fournies par l'utilisateur.
            Maryline n'est pas une personne humaine. Aucune décision n'est prise à votre place : l'analyse éclaire,
            vous décidez.
          </p>
        </section>

        <section className="space-y-3" data-testid="about-faq">
          {FAQ.map((f, i) => (
            <details key={i} className="group bg-white border border-[#E8DDD5] rounded-2xl px-5 py-4" data-testid={`about-faq-${i}`}>
              <summary className="cursor-pointer list-none flex items-center justify-between gap-4 font-semibold text-[#2B1E1B]">
                {f.q}
                <span className="text-[#C48B92] transition-transform group-open:rotate-45 text-xl leading-none">+</span>
              </summary>
              <p className="mt-3 text-[15px] text-[#4A3B37] leading-relaxed">{f.a}</p>
            </details>
          ))}
        </section>

        <footer className="mt-12 flex items-center gap-2 text-sm text-[#8C6B64]">
          <Heart className="w-4 h-4 text-[#6E2D38] fill-[#6E2D38]" /> RawLove — Comprenez. Analysez. Avancez.
        </footer>
      </div>
    </div>
  );
}
